import { motion } from "framer-motion";
import { ArrowRight } from 'lucide-react';
import { useNavigate } from "react-router-dom";

const CallToActionSection = () => {
    const navigate = useNavigate();

    return (
        <section className="py-24 relative overflow-hidden">

            <div className="container mx-auto px-4 text-center relative z-10">

                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    className="max-w-4xl mx-auto"
                >

                    {/* Titre */}
                    <h2 className="text-4xl sm:text-5xl md:text-7xl font-bold text-white mb-6 md:mb-8 leading-tight tracking-tight">
                        Prêt à
                        <span className="bg-gradient-to-r from-blue-400 via-cyan-300 to-blue-600 bg-clip-text text-transparent px-2 sm:px-4">
                            transformer
                        </span>
                        votre vision ?
                    </h2>

                    {/* Description */}
                    <p className="text-gray-300 text-base sm:text-xl mb-10 md:mb-12 max-w-2xl mx-auto leading-relaxed px-4">
                        Rejoignez les entreprises qui ont choisi l'excellence digitale avec Myriade
                    </p>

                    {/* Boutons d'action */}
                    <div className="flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-6 px-6 sm:px-0">

                        <button
                            onClick={() => navigate("/Contact")}
                            className="w-[180px] sm:w-[340px] cursor-pointer px-6 py-2 sm:px-8 sm:py-5 text-center text-[14px] sm:text-lg font-medium group relative bg-gradient-to-r from-blue-500 to-cyan-500 text-white font-semibold text-base sm:text-lg rounded-full overflow-hidden transition-all duration-300 hover:shadow-2xl hover:shadow-blue-500/30"
                        >

                            <span className="relative z-10 flex items-center justify-center gap-3">
                                Discutons de votre projet
                                <ArrowRight className="w-5 h-5 md:w-7 md:h-7 group-hover:translate-x-2 transition-transform" />
                            </span>

                        </button>

                        <button
                            onClick={() => navigate("/Temoignages")}
                            className="w-[180px] sm:w-[240px] cursor-pointer px-6 py-2 sm:px-8 sm:py-5 text-center text-[14px] sm:text-lg font-medium group relative bg-transparent border-2 border-gray-600 text-white font-semibold text-base sm:text-lg rounded-full overflow-hidden transition-all duration-300 hover:shadow-2xl hover:shadow-blue-500/30"
                        >
                            Voir nos réalisations
                        </button>

                    </div>

                </motion.div>

            </div>

        </section>
    );
};

export default CallToActionSection;
